@if (visible$ | async) { @if (productName$ | async; as productName) { @if (link()) {
<a
  class="product-title link-decoration-hover"
  data-testing-id="product-name-link"
  [routerLink]="productURL$ | async"
  [queryParamsHandling]="computedQueryParamsHandling"
  [queryParams]="{ page: null }"
  (click)="viewItemGTMEvent()"
  >{{ alternate() || productName }}</a
>
} @else {
{{ alternate() || productName }}
} } }
